import React from 'react';

const STEPS = [
  {
    n: '01',
    t: 'Enter dimensions & destination',
    d: 'Weight, box size, origin, destination. That\'s it — no account needed for a quote.',
  },
  {
    n: '02',
    t: 'Pick the rate that fits',
    d: 'Cheapest, fastest, greenest, or most reliable. Sort and filter across 24+ carriers.',
  },
  {
    n: '03',
    t: 'Print label, drop off, track',
    d: 'Download labels instantly. Drop at any partner location or schedule pickup. We handle the rest.',
  },
];

const TIMELINE = [
  { t: 'Package picked up', ts: 'Today · 09:12', done: true, active: false },
  { t: 'Departed origin facility', ts: 'Today · 14:45', done: true, active: false },
  { t: 'In transit', ts: 'ETA Tomorrow · 16:00', done: false, active: true },
  { t: 'Out for delivery', ts: '—', done: false, active: false },
];

const HowItWorksSection: React.FC = () => (
  <section className="page" style={{ paddingTop: 80 }}>
    <div className="home-hero">
      <div>
        <span className="kicker">How it works</span>
        <h2 style={{ fontSize: 40, fontWeight: 600, letterSpacing: '-0.025em', marginTop: 16 }}>
          Three steps from package to delivery.
        </h2>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 20, marginTop: 32 }}>
          {STEPS.map((s) => (
            <div
              key={s.n}
              style={{ display: 'flex', gap: 16, padding: 16, borderBottom: '1px solid var(--line)' }}
            >
              <div className="mono" style={{ fontSize: 20, fontWeight: 700, color: 'var(--brand-blue)' }}>
                {s.n}
              </div>
              <div>
                <div style={{ fontWeight: 600, fontSize: 17 }}>{s.t}</div>
                <div className="muted" style={{ marginTop: 4 }}>{s.d}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Tracking mock card */}
      <div
        className="card"
        style={{
          padding: 0,
          overflow: 'hidden',
          background: 'var(--brand-navy)',
          color: '#fff',
          border: 'none',
        }}
      >
        <div
          style={{ padding: 24, borderBottom: '1px solid rgba(255,255,255,0.08)' }}
        >
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div>
              <div
                style={{
                  fontSize: 12,
                  color: '#9a9fb8',
                  textTransform: 'uppercase',
                  letterSpacing: '0.08em',
                }}
              >
                Tracking
              </div>
              <div className="mono" style={{ fontSize: 18, marginTop: 4 }}>AS-482-ZH93-LK7</div>
            </div>
            <span className="badge badge-cyan">In transit</span>
          </div>
        </div>

        <div style={{ padding: 24 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 20 }}>
            <div>
              <div className="mono" style={{ fontSize: 11, color: '#9a9fb8' }}>FROM</div>
              <div style={{ fontWeight: 600 }}>Ramallah, PS</div>
            </div>
            <div
              style={{
                flex: 1,
                borderTop: '1.5px dashed rgba(255,255,255,0.25)',
                margin: '0 8px',
                position: 'relative',
              }}
            >
              <div
                style={{
                  position: 'absolute',
                  top: -8,
                  left: '55%',
                  background: 'var(--brand-cyan)',
                  padding: '2px 8px',
                  borderRadius: 99,
                  color: 'var(--brand-navy)',
                  fontSize: 10,
                  fontWeight: 700,
                }}
              >
                NOW
              </div>
            </div>
            <div style={{ textAlign: 'right' }}>
              <div className="mono" style={{ fontSize: 11, color: '#9a9fb8' }}>TO</div>
              <div style={{ fontWeight: 600 }}>Sheridan, WY</div>
            </div>
          </div>

          {TIMELINE.map((e, i) => (
            <div key={i} style={{ display: 'flex', gap: 12, padding: '10px 0' }}>
              <div
                style={{
                  width: 10,
                  height: 10,
                  borderRadius: 99,
                  marginTop: 6,
                  background: e.active
                    ? 'var(--brand-cyan)'
                    : e.done
                    ? '#fff'
                    : 'rgba(255,255,255,0.2)',
                  boxShadow: e.active ? '0 0 0 4px rgba(25, 198, 230, 0.2)' : 'none',
                }}
              />
              <div style={{ flex: 1 }}>
                <div
                  style={{
                    fontSize: 14,
                    fontWeight: e.active ? 600 : 400,
                    opacity: e.done || e.active ? 1 : 0.5,
                  }}
                >
                  {e.t}
                </div>
                <div className="mono" style={{ fontSize: 11, color: '#9a9fb8' }}>{e.ts}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default HowItWorksSection;
